import React, { useContext } from 'react';
import { bool } from 'prop-types';
import { useTranslation } from 'react-i18next';

import useStyles from 'hooks/useStyles';
import useGetCurrentDevice from 'hooks/useGetCurrentDevice';
import CourseContext from 'routes/course/components/CourseContext';
import CourseMeta from 'routes/course/components/CourseMeta';

import { COURSE_INFORMATION_TEMPLATE } from 'constants/routingPath';
import { DEFAULT } from 'constants/commonType';

import Link from 'components/Link';
import CircleProgressBar from 'components/CircleProgressBar';

import useGetOfficialSiteURL from 'hooks/useGetOfficialSiteURL';

import styles from './PlayListHeader.scss';

function PlayListHeader({ isLearningPage }) {
  useStyles(styles);
  const { t } = useTranslation(['course']);
  const getOfficialSiteURL = useGetOfficialSiteURL();

  const { isPC } = useGetCurrentDevice();

  const {
    id: courseId,
    name: courseName,
    learningProgress,
    lessonsAmount,
    userPurchased,
    completedLessonsLength,
  } = useContext(CourseContext);

  const courseLink = getOfficialSiteURL(COURSE_INFORMATION_TEMPLATE, {
    id: courseId,
  });

  const progress = (
    <li className={styles.flexWrapper}>
      <div className={styles.titleWrapper}>
        {isLearningPage && (
          <Link className={styles.link} type={DEFAULT} to={courseLink}>
            {courseName}
          </Link>
        )}
        <CourseMeta size="small" />
        <span className={styles.progressText}>
          {t('videoplayer.lessonComplete', {
            completed: completedLessonsLength,
            total: lessonsAmount,
          })}
        </span>
      </div>
      <div>
        <CircleProgressBar id="PlayListHeader" progress={learningProgress} />
      </div>
    </li>
  );

  return (
    <ul className={styles.root}>
      {userPurchased && progress}
      {!userPurchased && (
        <li>
          <CourseMeta size="small" showClose={!isPC} />
        </li>
      )}
    </ul>
  );
}

PlayListHeader.propTypes = {
  isLearningPage: bool.isRequired,
};

export default PlayListHeader;
